// extracted by mini-css-extract-plugin
module.exports = {"content":"error-page_content__1DHXa","button":"error-page_button__GtBjF"};